// src/pages/legal/DeleteAccountInfoPage.jsx
// A public page that says how to delete an account and what that removes: the app stores ask for such a page (a link that
// works without signing in), besides the deletion inside the app.
import React from 'react';
import { Link } from 'react-router-dom';
import TextPage, { Contact } from './TextPage';

function DeleteAccountInfoPage() {
    return (
        <TextPage title="Delete your account and data">
            <p>
                You can delete your Tournamental account, and everything in it, yourself, at any time, in the app or on the
                website. It takes effect immediately.
            </p>

            <h2>How</h2>
            <ol>
                <li>Open Tournamental (the app, or tournamental.app in a browser) and sign in.</li>
                <li>
                    Open <Link to="/account">Account</Link> (the link at the top right).
                </li>
                <li>
                    Scroll to <strong>Delete account</strong>, tap <strong>Delete my account</strong>, type DELETE to confirm and,
                    if asked, confirm that it is you (your password, or your Google or Apple account).
                </li>
            </ol>
            <p>
                If you cannot sign in any more, write to <Contact /> from the address of the account and we will delete it for
                you.
            </p>

            <h2>What is deleted</h2>
            <ul>
                <li>Your tournaments, players, rounds, scores and score history, and the backups of them.</li>
                <li>The read-only links you made (they stop working).</li>
                <li>
                    Tournaments you run with co-organizers <strong>and own</strong> are deleted for them too. In tournaments run
                    by others you simply leave.
                </li>
                <li>Your sign-in itself (your email address, name and account ID).</li>
                <li>The copy of your tournaments on the device you use for the deletion.</li>
            </ul>

            <h2>What can remain</h2>
            <p>
                Short-lived technical logs kept by our hosting providers, and error reports (which contain no personal data),
                are not tied to your account. Copies you exported or shared yourself are yours. See the{' '}
                <Link to="/privacy">privacy policy</Link>.
            </p>
        </TextPage>
    );
}

export default DeleteAccountInfoPage;
